import { PayeePaymentMethod } from '@willow/graphql-iso/src/app/backend';

import { assertNever } from './assertNever';

export const formatPayeePaymentMethod = (paymentMethod: PayeePaymentMethod): string => {
  switch (paymentMethod) {
    case PayeePaymentMethod.Check:
      return 'Check';
    case PayeePaymentMethod.Wire:
      return 'Wire';
    case PayeePaymentMethod.Ach:
      return 'ACH';
    case PayeePaymentMethod.AuthorizedAch:
      return 'Authorized ACH';
    default:
      assertNever(paymentMethod);
  }
};
